import React from "react";

export const IconOption8 = () => {
  return (
    <svg
      width="15"
      height="16"
      viewBox="0 0 15 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.8575 10.0878C14.8575 11.591 12.9035 12.8093 10.4924 12.8093C8.0813 12.8093 6.12733 11.591 6.12733 10.0878C6.12733 8.58465 8.0813 7.36719 10.4924 7.36719C12.9035 7.36719 14.8575 8.58544 14.8575 10.0878ZM10.4924 14.2831C8.0813 14.2831 6.12733 13.0648 6.12733 11.5624V13.2624C6.12733 14.7656 8.0813 15.9839 10.4924 15.9839C12.9035 15.9839 14.8575 14.7656 14.8575 13.2624V11.5624C14.8575 13.0648 12.9035 14.2831 10.4924 14.2831ZM4.93686 5.5529C7.34797 5.5529 9.30194 4.33465 9.30194 2.83227C9.30194 1.32989 7.34797 0.11084 4.93686 0.11084C2.52575 0.11084 0.571777 1.32909 0.571777 2.83227C0.571777 4.33544 2.52575 5.5529 4.93686 5.5529ZM4.83765 8.72751C5.21477 7.93845 5.81706 7.27871 6.5686 6.83147C6.0349 6.96435 5.48686 7.03099 4.93686 7.02989C2.52575 7.02671 0.571777 5.80846 0.571777 4.30608V6.00608C0.571777 7.49179 2.47654 8.691 4.83765 8.72433V8.72751ZM4.93686 15.9839C5.22312 15.9836 5.50911 15.9659 5.79321 15.9307C5.29454 15.4817 4.92005 14.9118 4.7059 14.2759C2.40273 14.2005 0.571777 13.0164 0.571777 11.5624V13.2624C0.571777 14.7656 2.52575 15.9839 4.93686 15.9839ZM4.54003 12.4569V10.7458C2.31781 10.6188 0.571777 9.4656 0.571777 8.04735V9.74814C0.571777 11.1672 2.31781 12.3331 4.54003 12.4569Z"
        fill="#F2F2F2"
      />
    </svg>
  );
};
